import { convertQFSymbolPositions } from "quickfire/integration/util/quickfire-utils";
import quickfire from "quickfire/quickfire";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import WaysResult from "slotworks/model/gameplay/records/results/ways-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import slotDefinition from "slotworks/model/slot-definition";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class WaysResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const win = data as QuickfireWin;

        return !!win.attributes.ways;
    }

    public build(record: Record, win: QuickfireWin): Result[] {
        const qfPayout = quickfire.paytable.get(win.attributes.paytableId);
        const symbolDef = slotDefinition.symbolDefinitions[qfPayout.symbolIndex];

        const result = new WaysResult();
        result.symbolType = symbolDef.id;
        result.cashWon = parseInt(win.attributes.amount);
        result.ways = parseInt(win.attributes.ways);
        result.positions = convertQFSymbolPositions(win.attributes.winSymbols);

        result.waysSymbols = [];
        result.positions.forEach((position) => {
            if (!result.waysSymbols[position.x]) {
                result.waysSymbols[position.x] = [];
            }
            const symbolId = (record as SpinRecord).grid[position.x][position.y];
            result.waysSymbols[position.x].push(symbolId);
        });

        result.flattenWaysSymbols();

        result.matches = result.symbols.length;
        result.multiplier = qfPayout.payout;
        result.perWayPayout = result.cashWon / result.ways;

        return [result];
    }
}

export default new WaysResultBuilder();
